import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
        <FAQSection />
        <AppSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <ContactSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}